import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ActiveFilterRow = styled.div`
  display: flex;
  gap: ${layout.measurements.spacing050};
  align-items: center;
  && {
    margin-top: ${layout.measurements.spacing050};
  }
`;
